import { createSlice } from '@reduxjs/toolkit';

import { loadAddressOptions } from './thunkActions/address';
import { IAdressState } from './types';

const getInitialState = (): IAdressState => ({
    districtes: [],
    barris: [],
    codiPostals: [],
    isLoaded: false,
    isLoading: false,
});

const addressSlice = createSlice({
    name: 'address',
    initialState: getInitialState(),
    reducers: {},
    extraReducers: builder => builder
        .addCase(loadAddressOptions.pending, state => ({ ...state, isLoading: true }))

        .addCase(loadAddressOptions.rejected, state => ({ ...state, isLoading: false }))

        .addCase(loadAddressOptions.fulfilled, (state, action) => ({ ...state, ...action.payload, isLoaded: true })),
});

// export const {  } = formsSlice.actions;

export const address = addressSlice.reducer;
